import Command from "./command"

import ColourIdeasCommand, {
  ColourIdeasCommandState,
} from "./idea/colour_ideas_command"
import ViewIdeaCommand, { ViewIdeaCommandState } from "./idea/view_idea_command"
import CreateIdeaCommand, {
  CreateIdeaCommandState,
} from "./idea/create_idea_command"
import DeleteIdeasCommand, {
  DeleteIdeasCommandState,
} from "./idea/delete_ideas_command"
import MoveIdeasCommand, {
  MoveIdeasCommandState,
} from "./idea/move_ideas_command"
import SetIdeaFieldCommand, {
  SetIdeaFieldCommandState,
} from "./idea/set_idea_field_command"
import SetIdeaSourceCommand, {
  SetIdeaSourceCommandState,
} from "./idea/set_idea_source_command"
import CreateFleetingIdeaCommand, {
  CreateFleetingIdeaCommandState,
} from "./fleeting_idea/create_fleeting_idea_command"
import DeleteFleetingIdeaCommand, {
  DeleteFleetingIdeaCommandState,
} from "./fleeting_idea/delete_fleeting_idea_command"
import CreateProjectCommand, {
  CreateProjectCommandState,
} from "./projects/create_project_command"
import SetProjectFieldsCommand, {
  SetProjectFieldsCommandState,
} from "./projects/set_project_fields_command"
import DeleteProjectCommand, {
  DeleteProjectCommandState,
} from "./projects/delete_project_command"
import CreateWebSourceCommand, {
  CreateWebSourceCommandState,
} from "./web_source/create_web_source_command"
import DeleteWebSourceCommand, {
  DeleteWebSourceCommandState,
} from "./web_source/delete_web_source_command"
import SetWebSourceFieldCommand, {
  SetWebSourceFieldCommandState,
} from "./web_source/set_web_source_field_command"
import SetWebSourceFieldsCommand, {
  SetWebSourceFieldsCommandState,
} from "./web_source/set_web_source_fields_command"

export const CommandNameToCommand = {
  "command:create-idea": CreateIdeaCommand,
  "command:delete-ideas": DeleteIdeasCommand,
  "command:move-ideas": MoveIdeasCommand,
  "command:colour-ideas": ColourIdeasCommand,
  "command:view-idea": ViewIdeaCommand,
  "command:set-idea-field": SetIdeaFieldCommand,
  "command:set-idea-source": SetIdeaSourceCommand,
  "command:create-fleeting-idea": CreateFleetingIdeaCommand,
  "command:delete-fleeting-idea": DeleteFleetingIdeaCommand,
  "command:create-project": CreateProjectCommand,
  "command:set-project-fields": SetProjectFieldsCommand,
  "command:delete-project": DeleteProjectCommand,
  "command:create-web-source": CreateWebSourceCommand,
  "command:delete-web-source": DeleteWebSourceCommand,
  "command:set-web-source-field": SetWebSourceFieldCommand,
  "command:set-web-source-fields": SetWebSourceFieldsCommand,
}

const Commands: Function[] = [
  CreateIdeaCommand,
  DeleteIdeasCommand,
  MoveIdeasCommand,
  ColourIdeasCommand,
  ViewIdeaCommand,
  SetIdeaFieldCommand,
  SetIdeaSourceCommand,
  CreateWebSourceCommand,
  DeleteWebSourceCommand,
  SetWebSourceFieldCommand,
  SetWebSourceFieldsCommand,
  CreateFleetingIdeaCommand,
  DeleteFleetingIdeaCommand,
  CreateProjectCommand,
  SetProjectFieldsCommand,
  DeleteProjectCommand,
]

export type CommandState =
  | CreateIdeaCommandState
  | DeleteIdeasCommandState
  | MoveIdeasCommandState
  | ColourIdeasCommandState
  | ViewIdeaCommandState
  | SetIdeaFieldCommandState
  | SetIdeaSourceCommandState
  | CreateFleetingIdeaCommandState
  | DeleteFleetingIdeaCommandState
  | CreateProjectCommandState
  | SetProjectFieldsCommandState
  | DeleteProjectCommandState
  | CreateWebSourceCommandState
  | DeleteWebSourceCommandState
  | SetWebSourceFieldCommandState
  | SetWebSourceFieldsCommandState

export {
  CreateIdeaCommand,
  DeleteIdeasCommand,
  MoveIdeasCommand,
  ColourIdeasCommand,
  ViewIdeaCommand,
  SetIdeaFieldCommand,
  SetIdeaSourceCommand,
  Commands,
  CreateWebSourceCommand,
  DeleteWebSourceCommand,
  SetWebSourceFieldCommand,
  SetWebSourceFieldsCommand,
  CreateFleetingIdeaCommand,
  DeleteFleetingIdeaCommand,
  CreateProjectCommand,
  SetProjectFieldsCommand,
  DeleteProjectCommand,
}
